import { getEntity, Publisher, PublisherEvaluationStatus } from '../../../../@data';
import { getCurrentUserContext } from '../../../../@data/store';

export async function fetchPublisherEvaluationStatus(publisher: Publisher): Promise<PublisherEvaluationStatus> {
  const publisherEvaluationStatus = new PublisherEvaluationStatus();

  // TODO: Make the API call only once and return the promise if multiple calls are made
  return await getEntity([publisherEvaluationStatus, publisher], getCurrentUserContext());
}
